import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/layout/Logo';
import { useApp } from '../contexts/AppContext';

export function MaintenancePage() {
  const { maintenance, ready } = useApp();
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && !maintenance) navigate('/dashboard', { replace: true });
  }, [ready, maintenance, navigate]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-100 p-6 dark:bg-gray-950">
      <div className="flex w-full max-w-lg flex-col items-center gap-6 rounded-2xl border border-gray-200 bg-white px-8 py-12 text-center shadow-2xl dark:border-gray-800 dark:bg-gray-900">
        <Logo size={48} />
        <h1 className="text-2xl font-semibold">System maintenance in progress</h1>
        <p className="max-w-sm text-sm text-gray-500">
          The OrqForge platform is currently being updated. This page refreshes when the API is ready.
        </p>
      </div>
    </div>
  );
}
